require('./bootstrap');

import 'babel-polyfill';

import Vue from 'vue';
import App from './containers/App';
import router from './router';
import store from './store';

require('./filters');
require('./mixins');

if (process.env.NODE_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}

const components = require.context('./components', true, /\.vue$/i);
if (components.length) {
    components.keys().map((key) => {
        let componentName = key.split('/').pop().split('.')[0];
        Vue.component(componentName.toLowerCase(), () => import(/* webpackChunkName: "Component-[request]" */ `./components/${componentName}.vue`))
    });
}

import Vuetify from "vuetify";

Vue.use(Vuetify);

import mdi from 'adminify-icons';
import * as mdiExtensions from './configuration/icons';

const icons = {
    ...mdi,
    ...mdiExtensions
};

new Vue({
    data() {
        return {
            currency_config: {
                locale: 'sv-SE',
                decimal: ',',
                prefix: 'R ',
                precision: 0,
                min: null,
                max: null,
                masked: false,
                allowNegative: true
            },
            currency_config_no_decimals: {
                locale: 'sv-SE',
                decimalLength: 0,
                prefix: 'R ',
                precision: 0,
                min: null,
                max: null,
                masked: false,
                allowNegative: true
            },
        }
    },
    el: '#app',
    computed: {
        appName() {
            return this.$store.getters['application/getName']
        },
        appUrl() {
            return this.$store.getters['application/getBaseUrl']
        }
    },
    router,
    vuetify: new Vuetify({
        theme: {
            dark: true,
            themes: {
                light: {
                    primary: '#3ed78f',
                    secondary: '#ff89aa',
                    accent: '#61CE70',

                    error: '#ef7167',
                    info: '#00bfd7',
                    success: '#8ac54d',
                    warning: '#ffba32',

                    background: '#E0E0E0',
                    inverted: '#0d2240'
                },
                dark: {
                    primary: '#3ed78f',
                    secondary: '#cf2e2e',
                    accent: '#ffffff',

                    error: '#ef7167',
                    info: '#00bfd7',
                    success: '#8ac54d',
                    warning: '#ffba32',

                    background: '#244d52',
                    inverted: '#fff'
                }
            }
        },

        // theme: {
        //     themes: {
        //         light: {
        //             primary: '#0d2240',
        //             secondary: '#ff89aa',
        //             accent: '#459ba8',
        //             alternative: '#0a325e',
        //
        //             info: '#00bfd7',
        //             success: '#8ac54d',
        //             danger: '#ef7167',
        //             warning: '#ffba32',
        //         },
        //     },
        // },
        icons: {
            iconfont: 'mdiSvg',
            values: icons
        },
    }),
    store,
    render: h => h(App)
});
